import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { startWebVitalsReporting } from "./lib/webVitalsReporter";
import { startConsentAudit } from "./lib/consentAudit";
import { ModuleLoadBoundary } from "./components/ModuleLoadBoundary";

startWebVitalsReporting();
startConsentAudit();


// Register Service Worker for caching
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available
                console.log('New content available, refresh for updates');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// Build-time static SEO tags are replaced by Helmet once React mounts.
document.querySelectorAll("head [data-ssg]").forEach((el) => el.remove());

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <ModuleLoadBoundary><App /></ModuleLoadBoundary>
  );
}

// Signal pre-renderer (Puppeteer) that the app is ready for snapshot.
// Wait two animation frames so React, Router, and Helmet flush first.
if (typeof window !== "undefined") {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        document.dispatchEvent(new Event("render-event"));
      }, 300);
    });
  });
}
